import { lazy, type ComponentType, type LazyExoticComponent } from "react";

export const DEFAULT_LOADER_MIN_MS = 750;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

/** Lazy import that resolves only after `minMs` so Suspense fallbacks stay visible briefly. */
export function lazyWithMinimumDelay<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
  minMs: number = DEFAULT_LOADER_MIN_MS,
): LazyExoticComponent<T> {
  return lazy(() => Promise.all([factory(), delay(minMs)]).then(([moduleExports]) => moduleExports));
}

export function remainingLoaderDelay(startedAt: number, minMs: number = DEFAULT_LOADER_MIN_MS): number {
  return Math.max(0, minMs - (Date.now() - startedAt));
}

export function waitLoaderMinDelay(startedAt: number, minMs: number = DEFAULT_LOADER_MIN_MS): Promise<void> {
  return delay(remainingLoaderDelay(startedAt, minMs));
}
